define('common/accordion',[
],
    function () {

        function init(selector) {
            $(selector + " .custom-accordion-title," + selector + " .custom-accordion-icon").off("click").on("click", accordionClick);
            // auto expand custom-accordion-item if needed
            $(selector + " .custom-accordion," + selector + ".custom-accordion").each(function (index, element) {
                var expandItemId = $(element).data("expandItemId");
                if (expandItemId) expandAccordionItem(selector, expandItemId);
            });
        }

        function accordionClick(event, clickedElement) {
            if (!clickedElement) clickedElement = this;
            // toggle accordion opened/closed
            $(clickedElement).toggleClass("open");
            $(clickedElement).siblings(".custom-accordion-content").toggleClass("open");
            $(clickedElement).siblings(".custom-accordion-title").toggleClass("open");
            // dispatch appropriate event for other modules to use
            if ($(clickedElement).hasClass("open")) dispatchEvent(clickedElement, "accordionOpened");
            else dispatchEvent(clickedElement, "accordionClosed");
        }

        function expandAccordionItem(selector, id) {
            var clickedElement = selector + " .custom-accordion-item[data-item-id='" + id + "']" + " .custom-accordion-title";
            if ($(clickedElement).length) {
                accordionClick(null, clickedElement);
                // scroll the accordion item into view if needed
                var pageTop = $(window).scrollTop();
                var pageBottom = pageTop + $(window).height();
                var elementTop = $(clickedElement).offset().top;
                var elementBottom = elementTop + $(clickedElement).height();
                if (elementTop < pageTop || elementBottom > pageBottom) {
                    $("html,body").animate({ scrollTop: $(clickedElement).offset().top - 80 });
                }
            }
        }

        function dispatchEvent(clickedElement, eventName) {
            var accordionItemElement = $(clickedElement).closest(".custom-accordion-item");
            var eventData = $(accordionItemElement).data("itemId");
            var event;
            var trueTypeOf = function (obj) {
                return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
            };
            if (trueTypeOf(window.CustomEvent) === 'function') {
                event = new CustomEvent(eventName, { bubbles: true, detail: eventData });
            } else {
                event = document.createEvent('CustomEvent');
                event.initCustomEvent(eventName, true, false, eventData);
            }
            $(accordionItemElement)[0].dispatchEvent(event);
        }

        return {
            init : init
        };
    });

